import { DELEGATION_HISTORY_TYPES } from '@constants/actionTypes/delegationActionTypes';

export const INITIAL_STATE = [];
export default (state= INITIAL_STATE, action = {} ) => {
    switch(action.type) {
        case (DELEGATION_HISTORY_TYPES.SET_DELEGATION_HISTORY):
            return action.delegationHistory;
        default:
            return state;
    }
};
